import CommonModal from "../../Component/Ui-Kits/Modal/Common/CommonModal";
import Btn from "../Button";
import P from "../Paragraph";

type ConfirmDeleteDialogProps = {
  isOpen: boolean;
  handleToggle: () => void;
  label: string;
  size?: string;
  description?: React.ReactNode | string;
  firstBtnLabel?: string;
  secondBtnLabel?: string;
  handleClickFirstBtn?: () => void;
  handleClickSecondBtn?: any;
  showCloseButton?: boolean;
  loading?: boolean;
  loadingText?: React.ReactNode | string;
};

const ConfirmDeleteDialog = ({
  isOpen,
  label,
  size = "md",
  firstBtnLabel = "Yes",
  secondBtnLabel = "No",
  handleToggle,
  handleClickFirstBtn,
  handleClickSecondBtn,
  showCloseButton = false,
  loading = false,
  loadingText,
  description,
}: ConfirmDeleteDialogProps) => {
  const handleSecondBtnClick = () => {
    if (secondBtnLabel?.toLowerCase() === "no") {
      handleToggle();
    } else {
      handleClickSecondBtn();
    }
  };

  return (
    <CommonModal
      size={size}
      centered
      showFooter={false}
      modalBodyClassName="ps-4"
      isOpen={isOpen}
      toggle={handleToggle}
      showCloseButton={showCloseButton}
      style={{ position: "relative" }}
    >
      <P className="mb-3 f-16 text-center">
        {loadingText && loading ? loadingText : label}
      </P>
      {description}

      {loading ? (
        <div className="d-flex justify-content-center align-items-center mb-3">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "2rem", height: "2rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center">
          <Btn
            className="rounded-pill btn-sm btn-info"
            onClick={handleClickFirstBtn}
          >
            {firstBtnLabel}
          </Btn>
          <Btn
            className="rounded-pill btn-sm btn-danger ms-3"
            onClick={handleSecondBtnClick}
          >
            {secondBtnLabel}
          </Btn>
        </div>
      )}
    </CommonModal>
  );
};

export default ConfirmDeleteDialog;
